module.exports = {
  notAvailable: 'Webshop is currently not available',
  webshop: 'Webshop',
  eng: 'English',
  de: 'Deutsch',
  error404: 'The page you are looking for does not exist!',
  invalid: 'Invalid',
  abr: 'Abbreviation',
  name: 'Name',
  phone: 'Phone',
  persons: 'Persons',
  call: 'Call',
  total: 'Total',
  status: 'Status',
  type: 'Type',
  restaurant: 'Restaurant',
  all: 'All',
  none: 'None',
  allNone: 'All/None',
  date: 'Date',
  paymentMethods: 'Payment methods',
  paymentReports: 'Payment Reports',
  deliveryMethods: 'Delivery methods',
  openPayments: 'Open payments',
  card: 'Card',
  cash: 'Cash',
  amazon: 'Amazon',
  cardmanual: 'Card Manual',
  deliveroo: 'Deliveroo',
  hungryhouse: 'Hungry House',
  invoice: 'Invoice',
  justeat: 'Justeat',
  ubereats: 'Ubereats',
  voucher: 'Voucher',
  galaxycard: 'Galaxy Card',
  collection: 'Collection',
  delivery: 'Delivery',
  website: 'Website',
  taxReport: 'Tax Report',
  itemUsage: 'Item Usage',
  cancellationReason: 'Cancellation reason',
  cancellationReasonFalseEntry: 'False entry',
  cancellationReasonGoodWill: 'Goodwill',
  cancellationReasonComplaint: 'Complaint',
  cancellationReasonReturn: 'Return',
  vattotal: 'VAT total',
  label: 'Label',
  driver: 'Driver',
  collectAll: 'Collect All',
  open: 'Open',
  sale: 'Sale',
  registerCard: 'Register Card',
  cardDetails: 'Card Details',
  walletDetails: 'Wallet Details',
  confirmed: 'Confirmed',
  pending: 'Pending',
  canceled: 'Canceled',
  shoppingBasket: 'Shopping basket',
  zNonTraining: 'Non-Training',
  zTraining: 'Training',
  orderDetails: 'Order summary',
  sysVersion: 'Backend version',
  resourceId: 'Resource id',
  orange: 'Orange',
  blue: 'Blue',
  green: 'Green',
  orderFees: 'Order fees',
  openingHours: 'Opening hours',
  quickLinks: 'Quicklinks',
  forgotPassword: 'Forgot password?',
  allRights: 'ALL Rights Reserved',
  selectMethod: 'Please select the method',
  byEmail: 'Reset by email address',
  byPhone: 'Reset by phone number',
  deliveryMethod: 'Delivery method',
  paymentProgress: 'Payment in progress',
  pleaseWait: 'Please wait',
  selectTime: 'Select time',
  orderHistory: 'Order History',
  attention: 'ATTENTION',
  foodAllergy: 'If you - or somebody you are ordering for - has a food allergy, please',
  callRestaurant: 'call the restaurant',
  language: 'Language',
  english: 'English',
  german: 'Deutsch',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  colours: 'Colours',
  experiment: 'Experiment',
  feVersion: 'Frontend version',
  theme: 'Theme',
  light: 'Light',
  dark: 'Dark',
  backTo: 'BACK TO',
};



// WEBPACK FOOTER //
// ./src/lang/en/global.js